import {z} from 'zod'
import {useParsedSearchParams} from '@/hooks/useParsedSearchParams'
import {MailLogStatus} from '@/features/mailer/types'

export const MailHistoryView = z.enum(['compose', 'history'])
export type MailHistoryView = z.infer<typeof MailHistoryView>

const MailHistoryParamsSchema = z.object({
    view: MailHistoryView.default('compose'),
    page: z.coerce.number().int().positive().default(1),
    limit: z.coerce.number().int().positive().max(50).default(10),
    search: z.string().trim().optional(),
    batch: z.string().uuid().optional(),
    detailPage: z.coerce.number().int().positive().default(1),
    detailStatus: MailLogStatus.optional()
})

export const useMailHistorySearchParams = () => useParsedSearchParams(MailHistoryParamsSchema)
